import { getAuth, signOut } from 'firebase/auth';
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// This will be replaced with the actual build timestamp during deployment
const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIME || 'development';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const logout = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      navigate("/");
    });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Hide footer on specific pages
  if (
    location.pathname === '/' 
    || location.pathname === '/chat/general'
  ) {
    return null;
  }

  return (
    <footer style={{
      width: '100%',
      backgroundColor: 'rgb(48, 48, 48)',
      color: 'rgba(255, 255, 255, 0.6)',
      padding: '16px 0',
      fontSize: '0.85rem',
      textAlign: 'center',
      marginTop: '0.8rem',
    }}>
      <Container>
        <div style={{ marginBottom: '8px' }}>
          <strong style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Spoons' Tracker</strong>
          {' - '}
          <a href="mailto:spoonstracker.com@gmail.com" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>spoonstracker.com@gmail.com</a>
        </div>
        <div style={{ marginBottom: '8px', color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>
          <Link to="/home" onClick={scrollToTop}>Home</Link>
          {' - '}
          <Link to="/pubs" onClick={scrollToTop}>Pubs</Link>
          {' - '}
          <Link to="/chat/general" onClick={scrollToTop}>Chat</Link>
          {' - '}
          <Link to="/settings" onClick={scrollToTop}>Settings</Link>
          {' - '}
          <Link to="/updates" onClick={scrollToTop}>Updates</Link>
          {' - '}
          <Link to="/support" onClick={scrollToTop}>Support</Link>
        </div>
        <div style={{ fontSize: '0.75rem', color: 'rgba(255, 255, 255, 0.5)' }}>
          Version: {BUILD_TIMESTAMP}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
